import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../App.css";
import MedicationResources from "../MedicationResources";
import Disclaimer from "../components/Disclaimer";
import { alternativetreatment } from "../data/alternativeData";
import TopBar from "../components/TopBar"; // ← reusable header (breadcrumb + avatar/login + white nav + modals)

const AlternativeTreatment = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const supplementFromSearch = queryParams.get("treatment");

  const defaultSupplement = supplementFromSearch || Object.keys(alternativetreatment)[0];
  const [showSidebar, setShowSidebar] = useState(false);
  const isMobile = typeof window !== "undefined" && window.innerWidth < 768;

  const [selectedSupplement, setSelectedSupplement] = useState(defaultSupplement);
  const [selectedSummary, setSelectedSummary] = useState(null);
  const [showTreatmentSelector, setShowTreatmentSelector] = useState(true);

  useEffect(() => {
    if (supplementFromSearch && alternativetreatment[supplementFromSearch]) {
      setSelectedSupplement(supplementFromSearch);
    }
  }, [supplementFromSearch]);

  if (!alternativetreatment[selectedSupplement]) {
    return <h2>Error: Treatment not found.</h2>;
  }

  const { name, description, cost, insuranceCoverage, resources } =
    alternativetreatment[selectedSupplement];

  const handleViewSummary = (summary) => {
    setSelectedSummary(summary);
  };

  const handleCloseSummary = () => {
    setSelectedSummary(null);
  };

  return (
    <div className="page-container">
      {/* Reusable header (breadcrumb + account dropdown + white nav + modals) */}
      <TopBar breadcrumb={`Alternative Therapies > ${alternativetreatment[selectedSupplement]?.name}`} />

      <div className="medications-container">
        {isMobile && showTreatmentSelector && (
          <div className="treatment-selector-overlay">
            <div className="overlay-header">
              <button
                className="back-button"
                onClick={() => setShowTreatmentSelector(false)}
              >
                ← Back
              </button>
              <h2>Alternative Therapies</h2>
            </div>
            <div className="overlay-treatments">
              {Object.keys(alternativetreatment).map((item) => (
                <div
                  key={item}
                  className={`category-card ${
                    selectedSupplement === item ? "active" : ""
                  }`}
                  onClick={() => {
                    setSelectedSupplement(item);
                    navigate(`/alternative-treatments?treatment=${encodeURIComponent(item)}`);
                    setShowTreatmentSelector(false);
                  }}
                >
                  <h3>{alternativetreatment[item].name}</h3>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* 🔽 Mobile toggle button */}
        {isMobile && !showTreatmentSelector && (
          <button
            className="select-treatment-button"
            onClick={() => setShowTreatmentSelector(true)}
          >
            Select a Treatment
          </button>
        )}

        {/* Layout */}
        <div className="medication-layout">
          {/* Sidebar */}
          <div className={`sidebar ${isMobile && showSidebar ? "open" : ""}`}>
            <h2 className="sidebar-title">Alternative Therapies</h2>
            <p className="sidebar-description">
              Explore holistic treatments and their research-backed effects on chronic pain.
            </p>
            <div className="sidebar-blocks">
              {Object.keys(alternativetreatment).map((supplement) => (
                <div
                  key={supplement}
                  className={`category-card ${
                    selectedSupplement === supplement ? "active" : ""
                  }`}
                  onClick={() => {
                    setSelectedSupplement(supplement);
                    navigate(`/alternative-treatments?treatment=${encodeURIComponent(supplement)}`);
                    if (isMobile) setShowSidebar(false);
                  }}
                >
                  <h3>{alternativetreatment[supplement].name}</h3>
                </div>
              ))}
            </div>
          </div>

          {/* Two-Box Content */}
          <div className="main-content">
            <div className="medication-info-box">
              <h2 className="medication-title">{name}</h2>
              <p className="medication-description">{description}</p>
              {cost && (
                <p className="medication-info">
                  <strong>Cost:</strong> {cost}
                </p>
              )}
              {insuranceCoverage && (
                <p className="medication-info">
                  <strong>Insurance Coverage:</strong> {insuranceCoverage}
                </p>
              )}
            </div>

            <div className="research-box">
              <h3 className="resources-title">
                Research on Holistic Treatments & Chronic Pain
              </h3>
              <MedicationResources
                resources={resources}
                onViewSummary={handleViewSummary}
              />
            </div>
          </div>
        </div>

        {selectedSummary && (
          <div className="summary-modal">
            <div className="modal-content">
              <button className="close-button" onClick={handleCloseSummary}>
                ×
              </button>
              <h3 style={{ textAlign: "left" }}>Summary</h3>
              <div className="summary-scroll">
                <p className="sidebar-description-left">{selectedSummary}</p>
              </div>
            </div>
          </div>
        )}
      </div>

      <Disclaimer />
    </div>
  );
};

export default AlternativeTreatment;
